import { RoleCode } from "features/RolesAndPermissions/constants/role.constants";
import type { User } from "features/Users/types/user.types";
import type { WorkOrder } from "features/WorkOrders/types/work-order.types";
import { workOrderAllowsRecordUpdate } from "features/WorkOrders/constants/work-order.constants";

function normalizedRoleCodes(user: User | null | undefined): string[] {
  return (user?.roles ?? []).map((r: { code: string }) => String(r.code).toLowerCase());
}

export function isAdminOrSuper(
  user: User | null | undefined,
  isSuperAdmin: boolean,
): boolean {
  if (isSuperAdmin) return true;
  const codes = normalizedRoleCodes(user);
  return codes.includes(RoleCode.SUPER_ADMIN);
}

export function workOrderPermissionFlags(
  user: User | null | undefined,
  workOrder: WorkOrder | null | undefined,
  isSuperAdmin: boolean,
) {
  const admin = isAdminOrSuper(user, isSuperAdmin);
  const canEdit = workOrderAllowsRecordUpdate(workOrder?.status);
  return {
    canEdit,
    isAdmin: admin,
  };
}
